import WorkOrderServer from './workorder'
import KnowledgeServer from './knowledge'
import PersonServer from './person'
import AssetServer from './asset'

export * from './server'

export {
  WorkOrderServer,
  KnowledgeServer,
  PersonServer,
  AssetServer,
}
